import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ContactRoutingModule } from './contact-routing.module';
import { ContactComponent } from './components/contact.component';
import { CanActivateViaAuthGuard } from '../../shared/services/auth.service'

@NgModule({
  imports: [
    CommonModule,
    ContactRoutingModule,
    TranslateModule.forChild()
  ],
  declarations: [ContactComponent],
  providers: [
    CanActivateViaAuthGuard
  ]
})
export class ContactModule { }
